module.exports = __webpack_public_path__ + "static/MS-dc5dfa27b6672cd2082fd01028e2974b.svg";